import { API } from "../../api";

function transformListResponse(responseData) {
  const data = responseData?.data;
  return {
    items: data?.items || [],
    pagination: data?.pagination || {},
  };
}

export const staffInvestorKycApi = API.injectEndpoints({
  endpoints: (builder) => ({
    listStaffInvestorKyc: builder.query({
      query: (params = {}) => ({
        url: "/cooperatives/investors/kyc",
        method: "GET",
        params,
      }),
      transformResponse: transformListResponse,
      providesTags: (result) =>
        result?.items?.length
          ? [
              ...result.items.map((item) => ({ type: "StaffInvestorKyc", id: item.id })),
              { type: "StaffInvestorKyc", id: "LIST" },
            ]
          : [{ type: "StaffInvestorKyc", id: "LIST" }],
    }),
    getStaffInvestorKyc: builder.query({
      query: (id) => ({
        url: `/cooperatives/investors/kyc/${id}`,
        method: "GET",
      }),
      transformResponse: (responseData) => responseData?.data,
      providesTags: (_result, _error, id) => [{ type: "StaffInvestorKyc", id }],
    }),
    approveStaffInvestorKyc: builder.mutation({
      query: (id) => ({
        url: `/cooperatives/investors/kyc/${id}/approve`,
        method: "POST",
      }),
      transformResponse: (responseData) => responseData?.data,
      invalidatesTags: (_r, _e, id) => [
        { type: "StaffInvestorKyc", id },
        { type: "StaffInvestorKyc", id: "LIST" },
      ],
    }),
    rejectStaffInvestorKyc: builder.mutation({
      query: ({ id, reason }) => ({
        url: `/cooperatives/investors/kyc/${id}/reject`,
        method: "POST",
        body: { reason },
      }),
      transformResponse: (responseData) => responseData?.data,
      invalidatesTags: (_r, _e, { id }) => [
        { type: "StaffInvestorKyc", id },
        { type: "StaffInvestorKyc", id: "LIST" },
      ],
    }),
    underReviewStaffInvestorKyc: builder.mutation({
      query: (id) => ({
        url: `/cooperatives/investors/kyc/${id}/under-review`,
        method: "POST",
      }),
      transformResponse: (responseData) => responseData?.data,
      invalidatesTags: (_r, _e, id) => [
        { type: "StaffInvestorKyc", id },
        { type: "StaffInvestorKyc", id: "LIST" },
      ],
    }),
    requestResubmissionStaffInvestorKyc: builder.mutation({
      query: ({ id, reason }) => ({
        url: `/cooperatives/investors/kyc/${id}/request-resubmission`,
        method: "POST",
        body: { reason },
      }),
      transformResponse: (responseData) => responseData?.data,
      invalidatesTags: (_r, _e, { id }) => [
        { type: "StaffInvestorKyc", id },
        { type: "StaffInvestorKyc", id: "LIST" },
      ],
    }),
    addStaffInvestorKycNote: builder.mutation({
      query: ({ id, note }) => ({
        url: `/cooperatives/investors/kyc/${id}/notes`,
        method: "POST",
        body: { note },
      }),
      transformResponse: (responseData) => responseData?.data,
      invalidatesTags: (_r, _e, { id }) => [{ type: "StaffInvestorKyc", id }],
    }),
    getStaffInvestorPortalSettings: builder.query({
      query: () => ({
        url: "/cooperatives/settings/investor-portal",
        method: "GET",
      }),
      transformResponse: (responseData) => responseData?.data,
      providesTags: [{ type: "InvestorPortalSettings", id: "CURRENT" }],
    }),
  }),
});

export const {
  useListStaffInvestorKycQuery,
  useGetStaffInvestorKycQuery,
  useApproveStaffInvestorKycMutation,
  useRejectStaffInvestorKycMutation,
  useUnderReviewStaffInvestorKycMutation,
  useRequestResubmissionStaffInvestorKycMutation,
  useAddStaffInvestorKycNoteMutation,
  useGetStaffInvestorPortalSettingsQuery,
} = staffInvestorKycApi;
